'use client';

import * as React from 'react';
import * as Sentry from '@sentry/nextjs';
import Error from 'next/error';
import { useEffect } from 'react';

export default function GlobalError({ error }: { error: Error }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  return (
    <html>
      <body>
        <Error statusCode={500} />
      </body>
    </html>
  );
}

GlobalError.displayName = 'GlobalError';
